// Mock Data for Magic Mountain Adventures

export const tourCategories = [
  { id: 'trekking', name: 'Trekking', icon: 'Mountain', description: 'Explore breathtaking Himalayan trails' },
  { id: 'mountain-biking', name: 'Mountain Biking', icon: 'Bike', description: 'Thrilling rides on mountain trails' },
  { id: 'ski-tours', name: 'Ski Tours', icon: 'Snowflake', description: 'Experience winter wonderland skiing' },
  { id: 'culture-tours', name: 'Culture Tours', icon: 'Landmark', description: 'Discover local heritage and traditions' },
  { id: 'nature-treat-hut', name: 'Nature Treat Hut', icon: 'TreePine', description: 'Serene stays amidst nature' },
  { id: 'cycling-tours', name: 'Cycling Tours', icon: 'Route', description: 'Epic cycling expeditions across the Himalayas' },
];

export const tours = [
  {
    id: 'hampta-pass',
    category: 'trekking',
    name: 'Hampta Pass Trek',
    duration: '5 Days / 4 Nights',
    difficulty: 'Moderate',
    altitude: '4,270m',
    groupSize: '8-15 people',
    price: 8999,
    originalPrice: 11999,
    rating: 4.9,
    reviews: 234,
    shortDesc: 'Cross the dramatic Hampta Pass and witness the magical transformation from lush Kullu valley to barren Lahaul.',
    description: 'The Hampta Pass trek is one of the most accessible crossover treks in the Himalayas. It takes you through green valleys of Kullu and dramatically transitions to the barren landscapes of Spiti. The trek offers diverse landscapes, river crossings, and camping under starlit skies.',
    highlights: ['Dramatic landscape transition', 'Chandratal Lake visit', 'River crossings', 'Camping at scenic locations', 'Snow bridge crossing'],
    images: [
      '/images/WhatsApp Image 2026-01-01 at 10.59.39 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.40 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.41 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.42 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.43 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.44 PM.jpeg',
      '/images/WhatsApp Image 2026-01-01 at 10.59.45 PM.jpeg'
    ],
    coverImage: '/images/WhatsApp Image 2026-01-01 at 10.59.45 PM.jpeg',
    itinerary: [
      { day: 1, title: 'Manali to Jobra to Chika', distance: '10km', activities: 'Drive to Jobra, trek to Chika through forests' },
      { day: 2, title: 'Chika to Balu ka Ghera', distance: '8km', activities: 'Trek through meadows, river crossings, camp setup' },
      { day: 3, title: 'Balu ka Ghera to Siagoru via Hampta Pass', distance: '11km', activities: 'Summit day! Cross Hampta Pass at 4,270m' },
      { day: 4, title: 'Siagoru to Chatru to Chandratal', distance: '6km trek + drive', activities: 'Trek to Chatru, drive to Chandratal Lake' },
      { day: 5, title: 'Chandratal to Manali', distance: 'Drive', activities: 'Sunrise at lake, drive back via Rohtang' }
    ],
    inclusions: ['Professional trek leader', 'Camping equipment', 'All meals during trek', 'Transport as per itinerary', 'First aid kit', 'Permits'],
    exclusions: ['Personal expenses', 'Travel insurance', 'Anything not mentioned in inclusions'],
    bestSeason: 'June to October',
    startPoint: 'Manali',
    endPoint: 'Manali'
  },
  {
    id: 'bhrigu-lake',
    category: 'trekking',
    name: 'Bhrigu Lake Trek',
    duration: '4 Days / 3 Nights',
    difficulty: 'Easy to Moderate',
    altitude: '4,300m',
    groupSize: '10-20 people',
    price: 6499,
    originalPrice: 8499,
    rating: 4.8,
    reviews: 189,
    shortDesc: 'Trek to the legendary lake where Sage Bhrigu is believed to have meditated.',
    description: 'Bhrigu Lake trek is a beautiful short trek near Manali. The high-altitude glacial lake is nestled in the Kullu region and offers spectacular views of the surrounding peaks.',
    highlights: ['Sacred glacial lake', 'Panoramic mountain views', 'Lush green meadows', 'Easy weekend trek', 'Suitable for beginners'],
    images: [
      '/images/8e0b2d912d61cc282a399c24cf0587d0.jpg',
      '/images/441dd0f89d712151453187a68a8147e7.jpg',
      '/images/cb5853dc7fb8acee8ab9e6aba8f6b43e.jpg'
    ],
    coverImage: '/images/441dd0f89d712151453187a68a8147e7.jpg',
    itinerary: [
      { day: 1, title: 'Manali to Gulaba to Rola Khuli', distance: '6km', activities: 'Drive to Gulaba, trek to campsite' },
      { day: 2, title: 'Rola Khuli to Bhrigu Lake and back', distance: '8km', activities: 'Early morning trek to lake, back to camp' },
      { day: 3, title: 'Rola Khuli to Gulaba to Manali', distance: '6km', activities: 'Trek down, drive to Manali' }
    ],
    inclusions: ['Expert guide', 'Camping gear', 'Meals', 'Transport', 'Permits'],
    exclusions: ['Personal gear', 'Insurance', 'Tips'],
    bestSeason: 'May to November',
    startPoint: 'Manali',
    endPoint: 'Manali'
  },
  {
    id: 'bara-bhangal',
    category: 'trekking',
    name: 'Bara Bhangal Trek',
    duration: '10 Days / 9 Nights',
    difficulty: 'Challenging',
    altitude: '4,878m',
    groupSize: '6-12 people',
    price: 32999,
    originalPrice: 42999,
    rating: 4.9,
    reviews: 67,
    shortDesc: 'The legendary Shepherds Trail crossing two high passes - Kalihani and Thamsar - to the mystical Bara Bhangal village.',
    description: 'The Bara Bhangal trek, also known as the Shepherds Trail, takes you over two high passes – Kalihani (4,725m) and Thamsar (4,878m). This classic Himalayan traverse takes you from Manali in Kullu valley to Billing in Kangra valley. The trek passes through secluded glades, ridges with panoramic views, rolling green meadows studded with wildflowers, and the mystical Bara Bhangal village - a remote ancient settlement at the conjunction of three districts.',
    highlights: ['Two high passes - Kalihani & Thamsar', 'Mystical Bara Bhangal village', 'Views of Deo Tibba & Indrasan', 'Glaciated terrain crossing', 'Option to paraglide from Billing', '360° views from passes'],
    images: [
      '/images/imageeeees.jpg',
      '/images/38cb05bfba35868021b37c72a63d3b0d.jpg',
      '/images/6de5db04eafeb15cd51529d199bfe789.jpg'
    ],
    coverImage: '/images/imageeeees.jpg',
    itinerary: [
      { day: 1, title: 'Arrive in Manali', distance: '-', activities: 'Briefing with guide, overnight at hotel' },
      { day: 2, title: 'Manali to Lama Dugh (3017m)', distance: '4-5 hrs', activities: 'Climb through thick forests, views of Indrasan, Deo Tibba open up' },
      { day: 3, title: 'Lama Dugh to Riyali Thach (3400m)', distance: '6-7 hrs', activities: 'Trek through steep ridge below Khand Pari Tibba, views of Manali and upper Kullu valley' },
      { day: 4, title: 'Riyali Thach to Base of Kalihani Pass (4010m)', distance: '5-6 hrs', activities: 'Open meadows, steep descent to stream, climb to base camp with views of Deo Tibba' },
      { day: 5, title: 'Cross Kalihani Pass (4725m) to Devi ki Marhi (3850m)', distance: '8 hrs', activities: 'Cross scree, moraine, Kalihani glacier. 360° views of Pir Panjal and Dhauladhar ranges' },
      { day: 6, title: 'Devi ki Marhi to Dal Marhi (3900m)', distance: '6 hrs', activities: 'Cross Kalihani Nullah, descend into oak and birch forests' },
      { day: 7, title: 'Dal Marhi to Bara Bhangal (2882m)', distance: '6 hrs', activities: 'Descend along Ravi river through deodar forest to the mystical village' },
      { day: 8, title: 'Bara Bhangal to Mardh (3830m)', distance: '5 hrs', activities: 'Start climbing towards Thamsar Pass through pine and deodar forests' },
      { day: 9, title: 'Cross Thamsar Pass (4878m) to Plachak (2721m)', distance: '7 hrs', activities: 'Steep ascent over moraine and glacier, first glimpse of Kangra valley from top' },
      { day: 10, title: 'Plachak to Rajgundha to Billing (2310m)', distance: '6 hrs', activities: 'Easy trek through pine forests, option to paraglide from Billing to Bir' }
    ],
    inclusions: ['Camping tents & equipment', 'Sleeping bags', 'All meals on trek', 'Guide, cook & camp staff', 'Horses/mules for luggage (10kg/person)', 'All forest permits', 'Transport Manali to Log Huts and Billing to Bir'],
    exclusions: ['Hotel stays in Manali', 'Food in hotels', 'Personal expenses', 'Medical & evacuation expenses', 'Travel insurance', 'Paragliding at Billing'],
    bestSeason: 'June to September',
    startPoint: 'Manali',
    endPoint: 'Bir'
  },
  {
    id: 'solang-biking',
    category: 'mountain-biking',
    name: 'Solang Valley Biking Trail',
    duration: '1 Day',
    difficulty: 'Moderate',
    altitude: '2,560m',
    groupSize: '4-10 people',
    price: 1999,
    originalPrice: 2999,
    rating: 4.6,
    reviews: 98,
    shortDesc: 'Pedal through scenic trails with mountain backdrops.',
    description: 'An exciting mountain biking adventure through Solang Valley. Ride through pine forests, apple orchards, and enjoy stunning views of snow-capped peaks.',
    highlights: ['Scenic trails', 'Professional bikes', 'Safety gear', 'Expert guides', 'Refreshments'],
    images: [
      '/images/WhatsApp Image 2025-12-30 at 9.32.32 PM.jpeg',
      '/images/WhatsApp Image 2025-12-30 at 9.32.33 PM.jpeg',
      '/images/WhatsApp Image 2025-12-30 at 9.32.34 PMM.jpeg',
    ],
    coverImage: '/images/WhatsApp Image 2025-12-30 at 9.32.32 PM.jpeg',
    itinerary: [
      { day: 1, title: 'Biking Adventure', distance: '25km', activities: 'Briefing, biking through trails, snack break, return' }
    ],
    inclusions: ['Mountain bike', 'Helmet', 'Guide', 'Snacks', 'Water'],
    exclusions: ['Personal insurance', 'Lunch'],
    bestSeason: 'March to November',
    startPoint: 'Manali',
    endPoint: 'Manali'
  },
  {
    id: 'solang-skiing',
    category: 'ski-tours',
    name: 'Solang Skiing Experience',
    duration: '1 Day',
    difficulty: 'Beginner to Advanced',
    altitude: '2,560m',
    groupSize: '2-8 people',
    price: 3499,
    originalPrice: 4999,
    rating: 4.8,
    reviews: 145,
    shortDesc: 'Experience the thrill of skiing in the Himalayas.',
    description: 'Learn or practice skiing at Solang Valley, one of the best skiing destinations in India. Professional instructors guide beginners while advanced skiers enjoy challenging slopes.',
    highlights: ['Professional instructors', 'Quality equipment', 'Multiple slopes', 'Safety training', 'Hot beverages'],
    images: [
      'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800',
      'https://images.unsplash.com/photo-1565992441121-4367c2967103?w=800',
      'https://images.unsplash.com/photo-1605540436563-5bca919ae766?w=800'
    ],
    coverImage: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=1200',
    itinerary: [
      { day: 1, title: 'Skiing Day', distance: 'N/A', activities: 'Training session, practice runs, free skiing, return' }
    ],
    inclusions: ['Ski equipment', 'Instructor', 'Safety gear', 'Hot drinks'],
    exclusions: ['Transport', 'Lunch', 'Personal insurance'],
    bestSeason: 'December to March',
    startPoint: 'Solang Valley',
    endPoint: 'Solang Valley'
  },
  {
    id: 'kullu-culture',
    category: 'culture-tours',
    name: 'Kullu Heritage Trail',
    duration: '2 Days / 1 Night',
    difficulty: 'Easy',
    altitude: '1,220m',
    groupSize: '6-12 people',
    price: 4499,
    originalPrice: 5999,
    rating: 4.7,
    reviews: 87,
    shortDesc: 'Explore ancient temples, local crafts, and traditional lifestyle.',
    description: 'Immerse yourself in the rich culture of Kullu Valley. Visit ancient temples, interact with local artisans, experience traditional cuisine, and learn about local customs.',
    highlights: ['Temple visits', 'Local crafts', 'Traditional food', 'Cultural performances', 'Artisan workshops'],
    images: [
      '/images/WhatsApp Image 2026-01-02 at 7.16.39 PMM.jpeg'
    ],
    videos: ['/videos/WhatsApp Video 2026-01-02 at 7.16.41 PM.mp4'],
    coverImage: '/images/WhatsApp Image 2026-01-02 at 7.16.39 PMM.jpeg',
    itinerary: [
      { day: 1, title: 'Temple Trail', distance: '30km', activities: 'Visit Hadimba Temple, Manu Temple, local market' },
      { day: 2, title: 'Cultural Immersion', distance: '25km', activities: 'Artisan village, cooking class, cultural show' }
    ],
    inclusions: ['Transport', 'Guide', 'Meals', 'Entry fees', 'Accommodation'],
    exclusions: ['Shopping', 'Personal expenses'],
    bestSeason: 'Year round',
    startPoint: 'Manali',
    endPoint: 'Manali'
  },
  {
    id: 'nature-hut-stay',
    category: 'nature-treat-hut',
    name: 'Riverside Eco Hut Stay',
    duration: '2 Days / 1 Night',
    difficulty: 'Easy',
    altitude: '2,050m',
    groupSize: '2-4 people',
    price: 5999,
    originalPrice: 7999,
    rating: 4.9,
    reviews: 203,
    shortDesc: 'Disconnect from the world in our serene riverside eco huts.',
    description: 'Experience the magic of staying in traditional wooden huts by the river. Wake up to birdsong, enjoy organic meals, and reconnect with nature.',
    highlights: ['Riverside location', 'Organic meals', 'Bonfire nights', 'Bird watching', 'Nature walks'],
    images: [
      '/images/WhatsApp Image 2025-12-29 at 1.28.08 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.19.53 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.19.54 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.20.00 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.34.16 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.34.17 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.34.18 PM.jpeg'
    ],
    coverImage: '/images/WhatsApp Image 2025-12-29 at 1.28.08 PM.jpeg',
    itinerary: [
      { day: 1, title: 'Arrival & Unwind', distance: 'N/A', activities: 'Check-in, nature walk, bonfire dinner' },
      { day: 2, title: 'Explore & Depart', distance: 'N/A', activities: 'Sunrise yoga, breakfast, checkout' }
    ],
    inclusions: ['Accommodation', 'All meals', 'Bonfire', 'Nature walk', 'Yoga session'],
    exclusions: ['Transport', 'Personal expenses'],
    bestSeason: 'Year round',
    startPoint: 'Manali',
    endPoint: 'Manali'
  },
  {
    id: 'manali-leh-cycle',
    category: 'cycling-tours',
    name: 'Manali to Leh Cycling Expedition',
    duration: '12 Days / 11 Nights',
    difficulty: 'Challenging',
    altitude: '5,400m',
    groupSize: '6-12 people',
    price: 55000,
    originalPrice: 67000,
    rating: 5.0,
    reviews: 89,
    shortDesc: 'The ultimate cycling adventure - 475km across five high passes including Tanglang La.',
    description: 'The Manali – Leh cycling tour is one of the most scenic, challenging and popular mountain biking routes. You cover 475 km over 10 days going past many high passes – Rohtang (3900m), Baralacha La (4800m), Nakee La (4850m), Lachulung La (4800m) and Tanglang La (5200m). From alpine forests and meadows in Manali through deep valleys in Lahaul, and vast plains in Sarchu, you enter Ladakh – a land that offers every hue of orange, red, brown and ochre.',
    highlights: ['5 high passes including Tanglang La', 'Suraj Tal Lake crossing', 'More Plains - Martian landscape', 'Thiksey Monastery visit', 'Professional support vehicle', 'High-grade camping'],
    images: [
      '/images/WhatsApp Image 2025-12-29 at 12.19.54 PMM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.19.55 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.19.56 PM.jpeg',
    ],
    coverImage: '/images/WhatsApp Image 2025-12-29 at 12.19.55 PM.jpeg',
    itinerary: [
      { day: 0, title: 'Arrive in Manali (2050m)', distance: '-', activities: 'Meet fellow riders, explore Manali cafes' },
      { day: 1, title: 'Acclimatisation & Gear Check', distance: '20km', activities: 'Ride to Solang valley, gear check, visit hot springs' },
      { day: 2, title: 'Manali to Marhi (3400m)', distance: '35km', activities: 'Hairpin bends through pine forests, reach alpine meadows' },
      { day: 3, title: 'Marhi to Sissu (3200m)', distance: '35km', activities: 'Cross Rohtang Pass at 4000m, follow Chandra river' },
      { day: 4, title: 'Sissu to Jispa (3300m)', distance: '50km', activities: 'Cycle through Keylong, Tandi confluence' },
      { day: 5, title: 'Jispa to Zing Zing Bar (4300m)', distance: '35km', activities: 'Leave inhabited Lahaul, climb to base of Baralacha La' },
      { day: 6, title: 'Zing Zing Bar to Sarchu (4350m)', distance: '50km', activities: 'Cross Baralacha La at 5000m, Suraj Tal Lake' },
      { day: 7, title: 'Sarchu to Pang (4400m)', distance: '76km', activities: 'Gatta Loops hairpins, cross Nakee La at 5150m' },
      { day: 8, title: 'Pang to Debring (4400m)', distance: '54km', activities: 'More Plains flatlands, spot wild Kiangs and Yaks' },
      { day: 9, title: 'Debring to Lato (3200m)', distance: '35km', activities: 'Cross Tanglang La at 5260m - highest pass!' },
      { day: 10, title: 'Lato to Leh (3400m)', distance: '70km', activities: 'Easiest day, cross villages and Thiksey Monastery' }
    ],
    inclusions: ['Camping tents & equipment', 'Sleeping bags (Down/Primaloft)', 'All meals on route', 'Cycling guide & support crew', 'Logistics vehicle', 'Hotels in Manali & Leh', 'High-grade camp accommodations'],
    exclusions: ['Mountain bike (rent available ₹12,000)', 'Food in Manali & Leh', 'Medical & evacuation expenses', 'Travel insurance', 'Return transport from Leh', 'Khardung La ride'],
    bestSeason: 'June to September',
    startPoint: 'Manali',
    endPoint: 'Leh'
  },
  {
    id: 'spiti-valley-cycle',
    category: 'cycling-tours',
    name: 'Spiti Valley Cycling Expedition',
    duration: '12 Days / 11 Nights',
    difficulty: 'Challenging',
    altitude: '4,600m',
    groupSize: '6-12 people',
    price: 60000,
    originalPrice: 75000,
    rating: 4.9,
    reviews: 56,
    shortDesc: 'Journey through ancient monasteries and the highest villages of Spiti to Kinnaur.',
    description: 'A 12 day trip that takes you from Manali, over Rohtang Pass and into the Lahaul valley along the Chandra river, over the Kunzum Pass to reach Spiti and continuing through the Kinnaur valley. Spiti is a cultural and religious mirror to Tibet. Ancient monasteries dot the brown valleys, interspersed with green villages. Visit Komic - the highest village connected by motorable road and the 1000-year-old monasteries of Dhankar and Tabo.',
    highlights: ['Kunzum Pass (4551m)', 'Chandratal Lake visit', 'Kee Gompa monastery', 'Komic - highest village', '1000-year-old Tabo monastery', 'Kinnaur valley greenery', 'Asia\'s highest bridge at Chicham'],
    images: [
      '/images/WhatsApp Image 2026-01-02 at 7.16.39 PM.jpeg',
      '/images/WhatsApp Image 2026-01-02 at 7.16.42 PM.jpeg',
      '/images/WhatsApp Image 2026-01-02 at 7.16.43 PM.jpeg',
      '/images/WhatsApp Image 2026-01-02 at 7.16.44 PM.jpeg',
      '/images/WhatsApp Image 2026-01-02 at 7.16.46 PM.jpeg',
      '/images/WhatsApp Image 2026-01-02 at 7.16.47 PM.jpeg'
    ],
    coverImage: '/images/WhatsApp Image 2026-01-02 at 7.16.46 PM.jpeg',
    itinerary: [
      { day: 0, title: 'Arrive in Manali (2050m)', distance: '-', activities: 'Meet fellow riders, evening briefing' },
      { day: 1, title: 'Acclimatisation & Gear Check', distance: '20km', activities: 'Ride to Solang valley, gear preparations' },
      { day: 2, title: 'Manali to Marhi (3400m)', distance: '35km', activities: 'Through pine forests and villages' },
      { day: 3, title: 'Marhi to Chatru (3400m)', distance: '50km', activities: 'Cross Rohtang Pass, reach Chandra river' },
      { day: 4, title: 'Chatru to Batal (3900m)', distance: '30km', activities: 'Cross Pagal Nalla, views of Chandrabhaga range' },
      { day: 5, title: 'Batal to Chandratal and back', distance: '30km', activities: 'Visit pristine crescent-shaped lake, rest day' },
      { day: 6, title: 'Batal to Hansa via Kunzum La (4551m)', distance: '42km', activities: 'Hardest day - cross gateway to Spiti' },
      { day: 7, title: 'Hansa to Komic (4500m)', distance: '65km', activities: 'Chicham bridge, Kee Gompa, highest village in world' },
      { day: 8, title: 'Komic to Tabo (3280m)', distance: '65km', activities: 'Via Demul, Dhankar monastery, 1000-year-old Tabo' },
      { day: 9, title: 'Tabo to Nako (3000m)', distance: '65km', activities: 'Lakeside village below Reo Purgyal (6816m)' },
      { day: 10, title: 'Nako to Spello (2400m)', distance: '62km', activities: 'Enter green Kinnaur, Spiti-Sutlej confluence' },
      { day: 11, title: 'Spello to Kalpa (2950m)', distance: '45km', activities: 'Views of Kinnaur Kailash, apple orchards' }
    ],
    inclusions: ['Camping tents & equipment', 'Sleeping bags', 'All meals on route', 'Guide, cook & helpers', 'Logistics vehicle', 'Hotel in Manali', 'Homestays in Komic, Tabo, Nako, Spello, Kalpa'],
    exclusions: ['Mountain bike (rent available ₹12,000)', 'Food in Manali', 'Medical expenses', 'Travel insurance', 'Transport from Reckong Peo onwards'],
    bestSeason: 'June to September',
    startPoint: 'Manali',
    endPoint: 'Kalpa'
  },
  {
    id: 'zanskar-cycle',
    category: 'cycling-tours',
    name: 'Zanskar Valley Cycling Expedition',
    duration: '13 Days / 12 Nights',
    difficulty: 'Challenging',
    altitude: '5,091m',
    groupSize: '6-10 people',
    price: 65000,
    originalPrice: 80000,
    rating: 4.9,
    reviews: 42,
    shortDesc: 'Journey to the mythical kingdom of Zanskar through the remote Shingo La pass.',
    description: 'The Zanskar Cycle tour is a 500km, 12-day expedition through the awe-inspiring landscapes of the Zanskar region. From Manali over Rohtang Pass, along the Chandra river, and over the Shingo La Pass (5091m) to reach the mythical Kingdom of Zanskar. Visit the spectacular 12th-century Phuktal Gompa built in a cave, and the ancient capital of Padum before cycling to Kargil.',
    highlights: ['Shingo La Pass (5091m)', 'Phuktal Gompa in a cave', 'Ancient Padum town', 'Pensi La crossing', 'Remote Zanskari villages', 'Suru Valley descent'],
    images: [
      '/images/WhatsApp Image 2025-12-29 at 11.45.37 AM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 11.45.38 AM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 11.45.39 AM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 11.45.40 AM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 11.45.46 AM.jpeg',
    ],
    coverImage: '/images/WhatsApp Image 2025-12-29 at 11.45.38 AM.jpeg',
    itinerary: [
      { day: 0, title: 'Arrive in Manali (2050m)', distance: '-', activities: 'Acclimatise and prepare' },
      { day: 1, title: 'Acclimatisation Day', distance: '20km', activities: 'Ride to Solang, gear check, hot springs' },
      { day: 2, title: 'Manali to Marhi (3400m)', distance: '35km', activities: 'Through villages and alpine meadows' },
      { day: 3, title: 'Marhi to Sissu (3200m)', distance: '35km', activities: 'Cross Rohtang Pass at 4000m' },
      { day: 4, title: 'Sissu to Jispa (3300m)', distance: '50km', activities: 'Through Keylong, along Chandrabhaga river' },
      { day: 5, title: 'Jispa to Zanskar Sumdo (3600m)', distance: '42km', activities: 'Leave Manali-Leh highway towards Zanskar' },
      { day: 6, title: 'Cross Shingo La (5091m) to Lakhang (4500m)', distance: '30km', activities: 'Pass day - spectacular views from top' },
      { day: 7, title: 'Lakhang to Purne (3700m)', distance: '40km', activities: 'First Zanskari villages, Gumburonjon rock' },
      { day: 8, title: 'Purne to Phuktal Gompa and back', distance: '-', activities: 'Visit 12th century monastery built in cave' },
      { day: 9, title: 'Purne to Padum (3000m)', distance: '50km', activities: 'Capital of erstwhile Zanskar kingdom' },
      { day: 10, title: 'Padum to Lalung Nala (2400m)', distance: '60km', activities: 'Base of Pensi La' },
      { day: 11, title: 'Lalung Nala to Tangol (2600m)', distance: '90km', activities: 'Cross Pensi La, Rangdum and Parkachik villages' },
      { day: 12, title: 'Tangol to Kargil (2400m)', distance: '75km', activities: 'Through Balti settlements to Kargil' }
    ],
    inclusions: ['Camping tents & equipment', 'Sleeping bags', 'All meals on route', 'Guide, cook & helpers', 'Logistics vehicle', 'Hotels in Manali, Padum & Kargil'],
    exclusions: ['Mountain bike (rent available ₹12,000)', 'Food in Manali, Padum & Kargil', 'Medical expenses', 'Travel insurance', 'Transport from Kargil onwards'],
    bestSeason: 'June to September',
    startPoint: 'Manali',
    endPoint: 'Kargil'
  },
    {
    id: 'Kerela-cycling-tour',
    category: 'cycling-tours',
    name: 'Kerela cycling tour',
    duration: '',
    difficulty: '',
    altitude: '',
    groupSize: '8-15 ',
    price: 0,
    originalPrice: 0,
    rating: 4.9,
    reviews: 0,
    shortDesc: 'Cycling tour in kerela.',
    description: 'contact for more deetails.',
    highlights: ['', '', '', '', ''],
    images: [
      '/images/WhatsApp Image 2025-12-29 at 12.01.49 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.01.50 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.01.51 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.01.52 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.01.54 PM.jpeg',
      '/images/WhatsApp Image 2025-12-29 at 12.01.57 PM.jpeg',
    ],
    coverImage: '/images/WhatsApp Image 2025-12-29 at 12.01.49 PM.jpeg',
    itinerary: [
      
    ],
    inclusions: [],
    exclusions: [],
    bestSeason: '',
    startPoint: '',
    endPoint: ''
  },
    {
    id: 'Rajasthan-cycling-tour',
    category: 'cycling-tours',
    name: 'Rajasthan cycling tour',
    duration: '',
    difficulty: '',
    altitude: '',
    groupSize: ' ',
    price: 0,
    originalPrice: 0,
    rating: 4.9,
    reviews: 0,
    shortDesc: 'Cycling tour in rajasthan.',
    description: 'contact for more deetails.',
    highlights: ['', '', '', '', ''],
    images: [
      'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800',
      'https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=800',
      'https://images.unsplash.com/photo-1454496522488-7a8e488e8606?w=800'
    ],
    coverImage: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1200',
    itinerary: [
      
    ],
    inclusions: [],
    exclusions: [],
    bestSeason: '',
    startPoint: '',
    endPoint: ''
  },
    {
    id: 'manali-dharamshala-cycling-tour',
    category: 'cycling-tours',
    name: 'manali dharamshala cycling tour',
    duration: '',
    difficulty: '',
    altitude: '',
    groupSize: '',
    rating: 4.9,
    reviews: 0,
    shortDesc: 'Cycling tour in himachal pradesh.',
    description: 'contact for more deetails.',
    highlights: ['', '', '', '', ''],
    images: [
      '/images/WhatsApp Image 2025-12-30 at 9.32.37 PM.jpeg',
      '/images/WhatsApp Image 2025-12-30 at 9.32.40 PM.jpeg',
      '/images/WhatsApp Image 2025-12-31 at 9.32.37 PM.jpeg',
      '/images/WhatsApp Image 2025-12-32 at 9.32.38 PM.jpeg',
      '/images/WhatsApp Image 2025-12-33 at 9.32.38 PM.jpeg',
    ],
    coverImage: '/images/WhatsApp Image 2025-12-32 at 9.32.38 PM.jpeg',
    itinerary: [
      
    ],
    inclusions: [],
    exclusions: [],
    bestSeason: '',
    startPoint: '',
    endPoint: ''
  }
];

export const galleryImages = [
  { id: 1, url: '/images/WhatsApp Image 2026-01-01 at 10.59.39 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 2, url: '/images/WhatsApp Image 2026-01-01 at 10.59.40 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 3, url: '/images/WhatsApp Image 2026-01-01 at 10.59.41 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 4, url: '/images/WhatsApp Image 2026-01-01 at 10.59.42 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 5, url: '/images/WhatsApp Image 2026-01-01 at 10.59.43 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 6, url: '/images/WhatsApp Image 2026-01-01 at 10.59.44 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 7, url: '/images/WhatsApp Image 2026-01-01 at 10.59.45 PM.jpeg', category: 'trekking', title: 'Hampta Pass Summit' },
  { id: 3, url: '/images/WhatsApp Image 2025-12-30 at 9.32.34 PM.jpeg', category: 'cycling', title: 'Rohtang' },
  { id: 3, url: '/images/WhatsApp Image 2025-12-30 at 9.32.35 PM.jpeg', category: 'cycling', title: 'Rohtang' },
  { id: 3, url: '/images/WhatsApp Image 2025-12-30 at 9.32.36 PM.jpeg', category: 'cycling', title: 'Rohtang' },  
  { id: 2, url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600', category: 'trekking', title: 'Bhrigu Lake' },
  { id: 3, url: '/images/WhatsApp Image 2025-12-30 at 9.32.37 PMM.jpeg', category: 'cycling', title: 'Rohtang' },
  { id: 4, url: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=600', category: 'ski-tours', title: 'Skiing Adventure' },
  { id: 5, url: '/images/WhatsApp Image 2025-12-30 at 9.32.32 PM.jpeg', category: 'mountain-biking', title: 'Solang Mountain Trail' },
  { id: 5, url: '/images/WhatsApp Image 2025-12-30 at 9.32.33 PM.jpeg', category: 'mountain-biking', title: 'Solang Mountain Trail' },
  { id: 5, url: '/images/WhatsApp Image 2025-12-30 at 9.32.34 PMM.jpeg', category: 'mountain-biking', title: 'Solang Mountain Trail' },
  { id: 6, url: 'images/WhatsApp Image 2025-12-29 at 1.28.08 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.19.53 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.19.54 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.20.00 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.34.16 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.34.17 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 6, url: '/images/WhatsApp Image 2025-12-29 at 12.34.18 PM.jpeg', category: 'nature-treat-hut', title: 'Eco Hut' },
  { id: 7, url: 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=600', category: 'culture-tours', title: 'Local Temple' },
  { id: 9, url: 'https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=600', category: 'trekking', title: 'Mountain Meadows' },
  { id: 10, url: '/images/WhatsApp Image 2025-12-30 at 9.32.37 PM.jpeg', category: 'cycling-tours', title: 'manali to dharamshala' },
  { id: 10, url: '/images/WhatsApp Image 2025-12-30 at 9.32.40 PM.jpeg', category: 'cycling-tours', title: 'manali to dharamshala' },
  { id: 10, url: '/images/WhatsApp Image 2025-12-31 at 9.32.37 PM.jpeg', category: 'cycling-tours', title: 'manali to dharamshala' },
  { id: 10, url: '/images/WhatsApp Image 2025-12-32 at 9.32.38 PM.jpeg', category: 'cycling-tours', title: 'manali to dharamshala' },
  { id: 10, url: '/images/WhatsApp Image 2025-12-33 at 9.32.38 PM.jpeg', category: 'cycling-tours', title: 'manali to dharamshala' },
  { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 12.19.54 PMM.jpeg', category: 'cycling-tours', title: 'Leh Highway' },
  { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 12.19.55 PM.jpeg', category: 'cycling-tours', title: 'Leh Highway' },
  { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 12.19.56 PM.jpeg', category: 'cycling-tours', title: 'Leh Highway' },
 { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 11.45.37 AM.jpeg', category: 'cycling-tours', title: 'Zanskar Cycling tour' },
  { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 11.45.38 AM.jpeg', category: 'cycling-tours', title: 'Zanskar Cycling tour' },
   { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 11.45.39 AM.jpeg', category: 'cycling-tours', title: 'Zanskar Cycling tour' },
    { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 11.45.40 AM.jpeg', category: 'cycling-tours', title: 'Zanskar Cycling tour' },
     { id: 11, url: '/images/WhatsApp Image 2025-12-29 at 12.01.46 PM.jpeg', category: 'cycling-tours', title: 'Zanskar Cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.39 PMM.jpeg', category: 'heritage-tour', title: 'Kullu heritage tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.42 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.43 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.44 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.46 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.47 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },
     { id: 11, url:   '/images/WhatsApp Image 2026-01-02 at 7.16.39 PM.jpeg', category: 'cycling-tour', title: 'Spiti cycling tour' },

];

export const testimonials = [
  {
    id: 1,
    name: 'Rahul Sharma',
    location: 'Delhi',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100',
    tour: 'Hampta Pass Trek',
    rating: 5,
    text: 'An unforgettable experience! The team was professional, the views were breathtaking, and the food was amazing. Highly recommended!'
  },
  {
    id: 2,
    name: 'Priya Patel',
    location: 'Mumbai',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100',
    tour: 'Manali to Leh Cycling',
    rating: 5,
    text: 'Life-changing adventure! The support crew was fantastic, and conquering Khardung La on a cycle is something I will never forget.'
  },
  {
    id: 3,
    name: 'Amit Kumar',
    location: 'Bangalore',
    avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100',
    tour: 'Rohtang Safari',
    rating: 5,
    text: 'Perfect family outing! Kids loved the snow, and the jeep ride was thrilling. Great value for money.'
  }
];

export const aboutUs = {
  title: 'About Magic Mountain Adventures',
  tagline: 'Where Every Peak Holds a Story',
  story: `Magic Mountain Adventures was founded by Raju Sharma (Prithiv Raj Sharma), a native Himalayan with over 25 years of experience in adventure tourism. Born and raised in the lap of the Himalayas at 2000 meters altitude, Raju has been passionate about sharing the magic of these mountains with adventurers from around the world.

Our journey began with a simple belief - that the best way to experience the Himalayas is through eco-friendly, sustainable tourism that respects both nature and local communities. Over the years, we have grown from a small trekking operation to a comprehensive adventure company offering trekking, cycling, skiing, and cultural tours.`,
  experience: '25+ Years of Experience',
  teamInfo: 'Our team members are very experienced and native from the Himalayas. We have been organizing expeditions like high altitude treks crossing the Zanskar range and Pir Panjal Range. Our mountain biking expertise spans 19 years, leading tours in Ladakh, Rajasthan, and Himachal Pradesh.',
  achievements: [
    'Recommended by Rough Guide and Footprint travel books',
    'Participated in Himalayan Mountain Biking Challenge 2005-2007',
    'Led 650km MTB Himachal race - climbing 12,000m in 9 days',
    'First event of its kind in India'
  ],
  values: [
    { title: 'Safety First', description: 'All expeditions led by certified and experienced guides with first aid training' },
    { title: 'Eco-Friendly', description: 'We believe in sustainable tourism and follow Leave No Trace principles' },
    { title: 'Local Expertise', description: 'Native Himalayan team with deep knowledge of the terrain and culture' },
    { title: 'Authentic Experiences', description: 'Connecting travelers with genuine mountain adventures and local communities' }
  ],
  founder: {
    name: 'Raju Sharma (Prithiv Raj Sharma)',
    role: 'Founder & Lead Guide',
    bio: 'Native Himalayan with 25+ years of experience in adventure tourism, passionate about eco-friendly tourism.'
  }
};

export const companyInfo = {
  name: 'Magic Mountain Adventures',
  tagline: 'Where Every Peak Holds a Story',
  phone: ['+91 98160 56934 ',
    '+91 94180 56934'
  ],
  whatsapp: '919816056934',
  email: 'magicmountain41@hotmail.com',
  address: 'Village Post Office Jagatsukh, Distt. Kullu (H.P.) India, PIN 175143',
  socialLinks: {
    instagram: 'https://instagram.com/magicmountainadventures',
    facebook: 'https://facebook.com/magicmountainadventures',
    youtube: 'https://youtube.com/magicmountainadventures'
  }
};

// Staff Dashboard Password
export const STAFF_PASSWORD = 'magic2024';

// Initial availability data (will be stored in localStorage)
export const initialAvailability = {};
tours.forEach(tour => {
  initialAvailability[tour.id] = [];
});
